import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController } from 'ionic-angular';
import firebase from 'firebase/app';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { LoadingProvider } from '../../providers/loading/loading';
import { Http, Headers, RequestOptions } from '@angular/http';
import {EnvDataService} from '../../app/services/env-data-service';
@Component({
  selector: 'page-api-credentials',
  templateUrl: 'api-credentials.html',
  providers:[EnvDataService]
})
export class ApiCredentialsPage {
  ApiCredentialsForm: FormGroup;
  public form_name: any;
  public uid: any;
  public mercuryApiKey: any;
  public activeCampaignApiKey: any;
  public getRole: any;
  public getemail = window.localStorage.getItem("email");
  public userRole : any;
  public validation_messages = {
    'mercuryApiKey': [
        { type: 'required', message: 'Mercury Api Key is required.' }
    ],
    'activeCampaignApiKey': [
      { type: 'required', message: 'Active Campaign Api Key is required.' }
    ]
  }
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    public formBuilder: FormBuilder, 
    public afs: AngularFirestore, 
    public modalCtrl: ModalController, 
    public afAuth:AngularFireAuth, 
    public toastCtrl: ToastController,
    public loadingProvider: LoadingProvider,
    public http: Http,
    private EnvDataService:EnvDataService
  ) {
    let thiss = this;
    thiss.uid = window.localStorage.getItem("uid");
    thiss.userRole = window.localStorage.getItem("userRole");
    var docRef0 = firebase.firestore().collection("global_credentials").doc('globalCredentials_API');
    docRef0.get().then(function(doc) {
      if (doc.exists) {
        let user_data = doc.data();
        thiss.mercuryApiKey = user_data.mercuryApiKey;
        thiss.activeCampaignApiKey = user_data.activeCampaignApiKey;
      } else {
        console.log("No such document!");
      }
    }).catch(function(error) {
      console.log("Error getting document:", error);
    });

    this.form_name = "eLINK Finance";
    this.ApiCredentialsForm = formBuilder.group({
      mercuryApiKey: ['', Validators.compose([Validators.required])],
      activeCampaignApiKey: ['', Validators.compose([Validators.required])]
    }); 
  }

  isFieldValid(field: string) {
    return !this.ApiCredentialsForm.get(field).valid && this.ApiCredentialsForm.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  save_credentials(){
    if(!this.ApiCredentialsForm.valid){
      this.ApiCredentialsForm.get('mercuryApiKey').markAsDirty();
      this.ApiCredentialsForm.get('mercuryApiKey').markAsTouched();

      this.ApiCredentialsForm.get('activeCampaignApiKey').markAsDirty();
      this.ApiCredentialsForm.get('activeCampaignApiKey').markAsTouched();
    }else{
      let uid = window.localStorage.getItem("uid");
      let mercuryApiKey = this.ApiCredentialsForm.value.mercuryApiKey;
      let activeCampaignApiKey = this.ApiCredentialsForm.value.activeCampaignApiKey;
      if(uid != null){
        this.loadingProvider.startLoading();
        
        var headers = new Headers();
        headers.append("Accept", 'application/json');
        headers.append('Content-Type', 'application/json' );
        const requestOptions = new RequestOptions({ headers: headers });
        let postData = {
          "uid": uid,
          "mercuryApiKey" : mercuryApiKey,
          "activeCampaignApiKey" : activeCampaignApiKey
        }
        console.log(postData);
        var url = this.EnvDataService.EnvData.sendbox_api+"/updateAPICredentials";
        this.http.post(url, postData, requestOptions)
        .subscribe(data => {
          if(data['_body'] == 'success'){
            this.loadingProvider.stopLoading();
            this.presentToastSuccess('Update Credentials successfully!');            
          }else{
            this.loadingProvider.stopLoading();  
            this.presentToastSuccess(data['_body']);          
          }
        }, error => {
          this.loadingProvider.stopLoading();
          this.presentToastmsg(error);
        });
      }
    }
  }
  presentToastmsg(err) {
    const toast = this.toastCtrl.create({
      message: err.message,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }
  presentToastSuccess(success) {
    const toast = this.toastCtrl.create({
      message: success,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad ApiCredentialsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/api-credentials/api-credentials.ts